import { Injectable, resource, signal } from '@angular/core';
import { Medarbejder } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejder.model';
import { RestDatasource } from '@core/api/rest.datasource';
import { MedarbejdereSearchParams } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejdere-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class MedarbejdereDatasource extends RestDatasource<Medarbejder> {
  override endpoint = '/api/admin/medarbejdere';

  searchParams = signal<MedarbejdereSearchParams>({
    text: '',
    medtagSlettede: false,
  });

  override data = resource({
    params: () => this.searchParams(),
    loader: async ({ params, abortSignal }) => {
      return await this.getList(
        {
          filter: JSON.stringify(params),
          sortBy: 'navn',
        },
        abortSignal
      );
    },
  });
}
